exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.renewalText {\r\n    font-size: 18px;\r\n    font-weight: bold;\n}\r\n", ""]);

// exports
